export const toFixed = (number, digits) => {
    return Math.trunc(number * Math.pow(10, digits)) / Math.pow(10, digits)
}

export const responseType = (type = 'message', is = 'message') => {
    type = type.toUpperCase()
    if (is === 'file') {
        switch (type) {
            case 'FILE':
            case 'F4025EN':
            case 'F4025FR':
            case 'F4037EN':
            case 'F4037FR':
            case 'FACE0002':
            case 'FACE0003':
            case 'FACE0005':
            case 'FACE0006':
            case 'FACE0007':
            case 'FACE0008':
            case 'FACE0009':
            case 'FACE0010':
            case 'FACE0011':
            case 'FACE0012':
            case 'FACE0013':
            case 'FACE0014':
            case 'FACE0015':
            case 'FACE0016':
            case 'FACE0017':
            case 'FACE0018':
            case 'FACE0019':
            case 'FACE0020':
            case 'FACE0021':
            case 'FACE0022':
            case 'FACE0023':
            case 'FACE0024':
            case 'PICTURE':
                return true
            default:
                return false
        }
    }

    if (is === 'message') {
        return type === 'MESSAGE' || type === 'FACE0001'
    }

    if (is === 'picture') {
        return type === 'PICTURE' || type === 'FACE0003'
    }

    if (is === 'confirmation') {
        return type === 'CONFIRMATION' || type === 'FACE0004'
    }
}

export const toFixedTrunc = (number, digits) => {
    const v = (typeof number === 'string' ? number : number.toString()).split('.')
    if (digits <= 0) return v[0]
    let f = v[1] || ''
    if (f.length > digits) return `${v[0]}.${f.substr(0, digits)}`
    while (f.length < digits) f += '0'
    return `${v[0]}.${f}`
}

export const useFormatter = (value, percent = false, prefix = '', suffix = '', decimal = 0) => {
    if (decimal > 0) {
        return parseFloat(value).toFixed(decimal)
    }

    const nf = Intl.NumberFormat('en-CA')

    const parse = parseFloat(value)
    if (isNaN(parse)) {
        return value
    }

    let val = nf.format(parse.toFixed(2))
    if (percent) {
        val = parseFloat(val) * 100
    }
    let ret = val

    if (prefix.length) {
        ret = `${prefix}${val}`
    }

    if (suffix.length) {
        ret = `${val}${suffix}`
    }

    return ret
}

export const useFormatterWithOptions = (
    options = {
        type: 'currency',
        value: '0',
        decimal: 2,
        symbol: false,
        suffix: '',
        prefix: ''
    }
) => {
    const { decimal = 2, value = 0, type = 'currency', symbol = false, suffix = '', prefix = '' } = options

    let ret

    if (type === 'decimal') {
        ret = toFixedTrunc(value, decimal)
    }

    if (type === 'rating') {
        ret = toFixedTrunc(value, 2)
    }

    if (type === 'integer') {
        ret = toFixedTrunc(value, 0)
    }

    if (type === 'percent') {
        ret = (toFixedTrunc(value, decimal) * 100).toFixed(decimal)
    }

    if (type === 'decimal' || type === 'percent') {
        if (prefix.length) {
            ret = `${prefix}${ret}`
        }

        if (suffix.length) {
            ret = `${ret}${suffix}`
        }

        return ret
    }

    if (type === 'currency') {
        const parse = parseFloat(value?.toString())
        if (isNaN(parse)) {
            return value
        }

        const nfOptions = symbol
            ? { style: 'currency', currency: 'CAD', currencyDisplay: 'symbol' }
            : { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 2 }

        const nf = Intl.NumberFormat('en-CA', nfOptions)
        return nf.format(parse)
    }
}
